// @flow

export function validateAndUpdateFeedbackPayload(payload: Object) {
  // Remove all occurrences of [anything]:// which looks like protocols from feedback text, to prevent from opening malicious links
  if (payload.feedbackText) {
    payload.feedbackText = payload.feedbackText.replace(/\w+:\/\//g, '');
  }
}
